import React from 'react';

// eslint-disable-next-line react/jsx-no-literals
const Nbsp = () => <span>&nbsp;</span>;

export default Nbsp;
